/**
 * Memoize a function
 *
 * @param fn - The function to memoize
 * @returns A memoized version of the function
 */
export const memoize = <T, Args extends unknown[]>(
  fn: (...args: Args) => T
): ((...args: Args) => T) => {
  const cache = new Map<string, T>();

  const memoized = (...args: Args): T => {
    const key = args.length ? JSON.stringify(args) : "__no_args__";

    if (cache.has(key)) {
      return cache.get(key)!;
    }

    const result = fn(...args);
    cache.set(key, result);
    return result;
  };

  return memoized;
};
